/*
  Footer link lists are rendered open (so desktops and no-JS browsers always see the links).
  On phones they collapse into accordions; this keeps the open/closed state in step with the screen width.
*/
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  function sync() {
    document.querySelectorAll('.footer-block__accordion').forEach(function (d) {
      if (phone.matches) {
        if (!d.dataset.userToggled) d.open = false;
      } else {
        d.open = true;
      }
    });
  }
  document.querySelectorAll('.footer-block__accordion-summary').forEach(function (s) {
    s.addEventListener('click', function () {
      s.parentElement.dataset.userToggled = '1';
    });
  });
  sync();
  if (phone.addEventListener) phone.addEventListener('change', sync);
})();
